/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Geliver_Substatus_Package_ForwardedInputs */

const tr_geliver_substatus_package_forwarded = /** @type {(inputs: Geliver_Substatus_Package_ForwardedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Farklı Kargoya Yönlendirildi`)
};

const en_geliver_substatus_package_forwarded = /** @type {(inputs: Geliver_Substatus_Package_ForwardedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Forwarded to Another Carrier`)
};

const de_geliver_substatus_package_forwarded = /** @type {(inputs: Geliver_Substatus_Package_ForwardedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`An anderen Zusteller weitergeleitet`)
};

const ru_geliver_substatus_package_forwarded = /** @type {(inputs: Geliver_Substatus_Package_ForwardedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Перенаправлено другому перевозчику`)
};

/**
* | output |
* | --- |
* | "Forwarded to Another Carrier" |
*
* @param {Geliver_Substatus_Package_ForwardedInputs} inputs
* @param {{ locale?: "tr" | "en" | "de" | "ru" }} options
* @returns {LocalizedString}
*/
export const geliver_substatus_package_forwarded = /** @type {((inputs?: Geliver_Substatus_Package_ForwardedInputs, options?: { locale?: "tr" | "en" | "de" | "ru" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Geliver_Substatus_Package_ForwardedInputs, { locale?: "tr" | "en" | "de" | "ru" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_geliver_substatus_package_forwarded(inputs)
	if (locale === "de") return de_geliver_substatus_package_forwarded(inputs)
	if (locale === "ru") return ru_geliver_substatus_package_forwarded(inputs)
	return tr_geliver_substatus_package_forwarded(inputs)
});